import { useQuery } from "@apollo/client/react";
import { type GQLRegionsQuery, type GQLRegionsQueryVariables } from "@src/graphql.generated";
import { useAttributeConfig } from "@src/hooks/useAttributeConfig";
import { regionsQuery } from "@src/main/Regions.gql";
import * as React from "react";

export const useCheckRegionAttribute = () => {
    const { region, setRegion } = useAttributeConfig();

    const { data } = useQuery<GQLRegionsQuery, GQLRegionsQueryVariables>(regionsQuery);

    React.useEffect(() => {
        if (data) {
            if (region === "") return;

            const regionExists = data.modelSpecifications.nodes.some((node) => node.name === region);
            if (!regionExists) {
                // eslint-disable-next-line no-console
                console.error(`Region ${region} does not exist"`);
                setRegion("EU");
            }
        }
    }, [data, region, setRegion]);
};
